var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer-container"},[_c('img',{staticClass:"footer-image",attrs:{"src":_vm.footerImage,"alt":"Footer"}})])}
var staticRenderFns = []

export { render, staticRenderFns }